import {__} from '@wordpress/i18n';

export default function TieredPricingBlock({attributes, quantity, discount, price, isSelected}) {

    let blockStyle = {
        padding: "0 10px",
        border: "1px solid #ccc",
        borderRadius: "5px",
        transition: "all .2s",
    }

    if (isSelected) {
        blockStyle.borderColor = attributes.activeTierColor;
        blockStyle.transform = "scale(1.06)";
    }

    return (
        <div className="tiered-pricing-block" style={blockStyle}>
            <div className="tiered-pricing-block__price" style={{fontWeight: 'bold', fontSize: '1.15em'}}>
                ${price}.00
            </div>
            <span className="tiered-pricing-block__quantity">
				<span>{quantity}</span> {__('pieces', 'tier-pricing-table')}
			</span>
        </div>
    )
}
